<template>
<div>
    <v-list>

        <v-list-item
            v-for="(location, index) in unarchived_locations"
            :key="index"
        >  
            <v-list-item-avatar><v-icon>mdi-map-marker</v-icon></v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title><b>{{location.internal_label}}</b></v-list-item-title>
                <v-list-item-content>
                    <m-address
                        :value="location.address"
                    />
                </v-list-item-content>
            </v-list-item-content>

            <v-list-item-action 
                v-if="can_write"
            >
                <v-menu 
                    bottom 
                    offset-y  
                >

                <template v-slot:activator="{ on }">
                        
                    <v-icon 
                        v-on="on"
                    >
                        mdi-dots-vertical
                    </v-icon>
                        
                </template>

                <v-list>
                    <v-list-item
                        v-on:click="onEditLocation(index)"
                    >
                        <v-list-item-title>Edit...</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        v-on:click="onEditCurbside(index)"
                    >
                        <v-list-item-title>Curbside Pickup Settings...</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        v-on:click="onDeleteLocation(index)"
                    >
                        <v-list-item-title>Delete...</v-list-item-title>
                    </v-list-item>
                </v-list>

                </v-menu> 
            </v-list-item-action>
        </v-list-item>
        
</v-list>

    <m-icon-bar
        v-on:add="onAddLocation"
        v-if="can_write"
    />

<m-edit-location-dialog
    ref="edit-location-dialog"
    v-on:ok="$emit('reload');"
/>

<m-edit-location-curbside-dialog
    ref="edit-location-curbside-dialog"
    v-on:ok="$emit('reload');"
/>


</div>
</template>

<script>
export default {
    props: {
        profile: {
            type: Object,
            default: function() {}
        },
    },

    methods: {
        onDeleteLocation(index) {
            let location = this.unarchived_locations[index];

             this.$rc.confirm(
                'Delete Location \'' +location.internal_label+'\'',
                'Permenantly delete this location?',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Delete', 'value' : 'confirmed' },
                ],

                (response) => {
                    if ( response != 'confirmed' ) return;
                    
                    this.onDoDelete(index);
                }
            );
        },

        onDoDelete(index)
        {   
            let location = this.unarchived_locations[index];
            location.archived = true;

            this.$rc.showSpinner();
            
            this.$rc.upsertLocation(
                location,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar('Location Deleted',3500);

                    this.$emit('reload');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onAddLocation()
        {
            let organization_id = this.profile.organization_account.organization_id;
            this.$refs['edit-location-dialog'].showDialogNewLocation(organization_id);
        },

        onEditLocation(index)
        {
            let location = this.unarchived_locations[index];
            this.$refs['edit-location-dialog'].showDialog(location);
        },

        onEditCurbside(index)
        {
            let location = this.unarchived_locations[index];
            this.$refs['edit-location-curbside-dialog'].showDialog(location);
        },
    },

    computed: {
        unarchived_locations() 
        {
            if ( this.profile == null ) return [];
            if ( this.profile.locations == null ) return [];

            let ret = [];

            for ( let i = 0; i < this.profile.locations.length; i++ )
            {
                if ( this.profile.locations[i].archived ) continue;
                ret.push(this.profile.locations[i]);
            }
            
            return ret;
        },

        can_write() {
            return this.profile.actor_permissions.can_write; 
        }
    },
}
</script>

<style lang="scss" scoped>

</style>